import api from './interceptor'

// 获取可预约日期
export const getBookableDates = params => {
  return api.get('/oab/bookableDates', { params })
}

// 获取座席号(可预约时间)
export const getTimeslotSeats = params => {
  return api.get('/oab/timeslotSeats', { params })
}

// 获取车型车系
export const getModelData = params => {
  return api.get('/oab/getCarList', { params })
}

// 获取经销商
export const getOabDealer = params => {
  return api.get('/oab/getDealer', { params })
}

// 获取经销商营业时间
export const getDealerOpenTime = params => {
  return api.get('/oab/getDealerOpenTime', { params })
}

// 创建预约
export const createReservation = params => {
  return api.post('/oab/reservation', params)
}
// 创建预约二次确认
export const createReservationSecond = params => {
  return api.post('/oab/reservation', params)
}

// 获取预约列表数据
export const getOrderList = params => {
  return api.get('/oab/getAppointmentList', { params })
}

// 取消预约订单
export const cancleOab = params => {
  return api.post('/oab/cancelReservation', params)
}

// 获取预约详情数据
export const getOrderDetail = params => {
  return api.get('/oab/getAppointmentByID', { params })
}
